import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PilotHttpClient } from 'src/app/shared/flight-log-api/pilots/pilot-client.service';
import { PilotEntity } from 'src/store/pilot/pilot.model';
import { PilotUpdateSubEntitiesStateDialogComponent } from '../pilot-update-sub-entities-state-dialog/pilot-update-sub-entities-state-dialog.component';

@Component({
  selector: 'fl-pilot-detail-page',
  templateUrl: './pilot-detail-page.component.html',
  styleUrls: ['./pilot-detail-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotDetailPageComponent implements OnInit {
  public pilot$: Observable<PilotEntity | undefined>;
  public activeTab = 0;
  public airCarrier = this._route.snapshot.data.airCarrier;

  constructor(
    private _route: ActivatedRoute,
    private _pilot: PilotHttpClient,
    private _dialog: MatDialog,
  ) {}

  public ngOnInit() {
    const pilotResult$ = this._route.params.pipe(
      map((p) => p.id),
      switchMap((id) => this._pilot.getById(id).pipe(map((r) => r))),
    );
    this.pilot$ = pilotResult$.pipe(map((res) => res.results[0]));
  }

  public setActiveTab(event: MatTabChangeEvent) {
    this.activeTab = event.index;
  }

  public bulkUpdate(pilotId: string) {
    this._dialog.open(PilotUpdateSubEntitiesStateDialogComponent, {
      data: {
        pilotId,
      },
      disableClose: true,
    });
  }
}
